import { render, staticRenderFns } from "./AttachmentEdit.vue?vue&type=template&id=8fd92164"
import script from "./AttachmentEdit.vue?vue&type=script&lang=js"
export * from "./AttachmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports